export default {
  state: {
    user: {},
    isLoggedIn: false,
    loginDialog: false,
    isSelectedGuestLogin: false,
    deviceCoordinates: {},

    storeId: null,
    groupId: null,

    kioskMode: false
  },
  getters: {
    getAuthUser(state){
      return state.user
    },
    getAuthToken(state) {
      return state.user.authToken
    },
    getPhone(state) {
      return state.user.telephone
    },
    getEmail(state) {
      return state.user.email
    },
    getFirstName(state) {
      return state.user.firstName
    },
    getLastName(state) {
      return state.user.lastName
    },
    getUserID(state) {
      return state.user.id
    },
    isLoggedIn(state) {
      return state.isLoggedIn
    },
    isSelectedGuestLogin(state){
      return state.isSelectedGuestLogin
    },
    showLoginDialog(state) {
      return !!state.loginDialog
    },
    getDeviceCoordinates(state) {
      return state.deviceCoordinates
    },

    getStoreId(state) {
      return state.storeId
    },
    getGroupId(state) {
      return state.groupId
    },

    isInKioskMode: (state) => state.kioskMode
  },
  actions: {
    setDeviceCoordinates({ commit }, coordinates) {
      commit('SET_DEVICE_COORDINATES', coordinates)
    },
    logoutAuthUser({ commit }) {
      return this.$api.post('/customer/logout').then(res => {
        commit('unsetAuthUser')
        commit('SET_CUSTOMER_REWARDS', {})
        commit('SET_AI_RECOMMENDATIONS', [])
        commit('SET_AI_CART_RECOMMENDATIONS', [])
      })
    },
    async logout({ commit, dispatch, getters }) {
      dispatch('groupOrder/clearGroupOrder')
      commit('unsetAuthUser')
      commit('SET_CUSTOMER_REWARDS', {})
      // Recommendations were personalized off the account's own phone/auth token --
      // stale on logout the same way coupons/rewards are, in case another guest uses
      // this device next.
      commit('SET_AI_RECOMMENDATIONS', [])
      commit('SET_AI_CART_RECOMMENDATIONS', [])

      // Preserve lastStoreId before clearing vuex so the store-switch guard
      // in App.vue doesn't mistake logout as a store change and trigger a reload loop
      var lastStoreId = window.localStorage.getItem('lastStoreId')
      window.localStorage.removeItem('vuex')
      if (lastStoreId) window.localStorage.setItem('lastStoreId', lastStoreId)

      // clear all the users selected punchCards
      const punchCards = getters.getPunchCards || []
      for (let punchCard of punchCards) {
        punchCard.using = null
        delete punchCard.using
      }

      commit('SET_ACTIVE_COUPON', null)
      dispatch('fetchAllCoupons')
      // Mirrors login's own fetchAiRecommendations dispatch above -- StorePage.vue only
      // fires that once, on mount, so without this a guest who logs out mid-session saw
      // the row go blank (SET_AI_RECOMMENDATIONS([]) just above) and never refilled with
      // the anonymous /ai/popular-items fallback (see menu.js) until a page refresh.
      dispatch('fetchAiRecommendations')
      dispatch('fetchAiCartRecommendations')
    },
    login({ commit, dispatch }, { telephone, code, referrer }) {
      let _req = { telephone, code, referrer }

      return this.$api.post('/customer/login', _req)
        .then(res => {
          commit('setAuthUser', { user: res.data, authToken: res.headers.authorization })
          // Same for the cart row: swap the guest best-sellers for personalized picks.
          dispatch('fetchAiCartRecommendations')
          // Logging in mid-session (no page reload) is the only way getPhone becomes
          // available without a fresh fetchAiRecommendations dispatch -- StorePage.vue
          // only fires that once, on mount, so a guest who logs in after landing on the
          // menu never saw the AI row until they refreshed.
          dispatch('fetchAiRecommendations')
        })
    },
    loginRequest({ commit }, { telephone }) {
      let _req = { telephone }

      return this.$api.post('/customer/login/request', _req)
    }
  },
  mutations: {
    SET_DEVICE_COORDINATES(state, coordinates) {
      const { latitude, longitude } = coordinates || {}

      state.deviceCoordinates = { latitude, longitude }
    },
    unsetAuthUser(state){
      state.user = {}
      state.isLoggedIn = false
    },
    setAuthUser(state, { user, authToken } ) {
      state.user = user
      state.user.authToken = authToken
      state.isLoggedIn = true
    },
    setSelectedGuestLogin(state, payload){
      state.isSelectedGuestLogin = payload
    },
    setLoginDialog(state, payload) {
      state.loginDialog = !!payload
    },

    SET_STORE_ID(state, payload) {
      state.storeId = payload
    },
    SET_GROUP_ID(state, payload) {
      state.groupId = payload
    },

    SET_KIOSK_MODE(state, val) {
      state.kioskMode = val
    }
  }
}
